import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./components";

Vue.config.productionTip = false;

const init = () => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
};

// 通过登录接口获取用户登录信息
const getLoginInfo = () => {
  store.dispatch("setUserInfo").then((res) => {
    handleSuccess(res);
  });
};

// 获取用户信息成功
const handleSuccess = (res) => {
  const { errcode, data } = res;
  console.log(data, "-");
  if (errcode === 0) {
    store.commit("SET_USER_INFO", data);
    init();
  }
};

// g_loginUserInfo获取用户登录信息;
getLoginInfo();

// init();
